// 261025 3d1 — hàm THUẦN của cổng chấm → tự sửa ≤ 2 vòng trong chuỗi truyện mới: thẻ «Chờ bạn quyết · Chặng 2/3» (WAIT_REVIEW_GATE), chữ theo lý do dừng,
// khối «lịch sử vòng» ở cổng ③④, nhãn tiến độ. KHÔNG import antd / react (jest của react-scripts không load được antd v6). `.tsx` chỉ vẽ và gọi API.
import type { AppendRunGateWait } from '../../../types/adaptationWorkbench';
import type { ChainGateStopReason, GateRound, StepGate } from '../../../types/adaptation';

/** CHÉP từ BE `SYSTEM_NEW_STORY_ACTOR` (`utils/systemActor.ts`). */
export const MACHINE_ACTOR = 'SYSTEM_NEW_STORY_RUN';
export const MACHINE_ACTOR_LABEL = 'Máy';
export const REVIEW_GATE_LABEL = 'Chờ bạn quyết · Chặng 2/3';
export const GATE_OPEN_LABEL = 'Mở ③ Bản địa hoá';
export const GATE_REGRADE_LABEL = 'Tôi đã sửa — chấm lại';
export const GATE_CONTINUE_LABEL = 'Chạy tiếp, để lỗi xem sau';
/** 3g2 (Q9/R1): ③ đang BLOCKED (lỗi khách quan) — máy không tự đi tiếp, «để lỗi xem sau» không dùng được; đường duy nhất là «Vẫn tiếp tục» (kèm lý do) ở thẻ Bản địa hoá. */
export const GATE_BLOCKED_OPEN_LABEL = 'Mở ③ Bản địa hoá để xử lý';
export const GATE_BLOCKED_LINE = 'Cổng Bản địa hoá đang CHẶN (lỗi khách quan): mở thẻ Bản địa hoá, sửa lỗi rồi chấm lại, hoặc bấm “Vẫn tiếp tục” kèm lý do.';

/** Lý do chuỗi dừng ở cổng (chữ người đọc). Mã lạ ⇒ câu chung, KHÔNG lộ mã thô. */
export const GATE_STOP_TEXT: Record<ChainGateStopReason, string> = {
  NONE: 'Cổng còn lỗi chưa gỡ',
  NO_CONVERGENCE: 'Vòng sửa đầu không làm giảm lỗi nên máy dừng, không thử tiếp',
  ROUNDS_EXHAUSTED: 'Máy đã sửa đủ 2 vòng mà vẫn còn lỗi',
  NOTHING_FIXABLE: 'Các lỗi còn lại máy không tự sửa được (đã khoá hoặc cần người quyết)',
  GATE_ERROR: 'Máy chưa chấm được cổng này (lỗi lúc chấm) nên chưa biết còn lỗi nào',
  GATE_MISSING: 'Cổng chưa chấm xong hoặc bị lỗi nên chưa biết còn lỗi nào',
  GATE_STALE: 'Bản địa hoá đã đổi sau lần chấm cuối nên kết quả chấm không còn đúng',
};
const GATE_STOP_FALLBACK = 'Cổng AI chưa cho qua';
export const gateStopText = (r: string | null | undefined): string => (r && (GATE_STOP_TEXT as Record<string, string>)[r]) || GATE_STOP_FALLBACK;

/** Chữ lý do một mục bị bỏ qua / chuyển cho người ở một vòng. Mã lạ ⇒ câu chung. */
export const ROUND_SKIP_TEXT: Record<string, string> = {
  LOCKED_WRITTEN: 'đã viết/đã đẩy, khoá', OVER_CAP: 'vượt trần số tập mỗi vòng', BUDGET: 'đã đạt giới hạn AI của truyện', OUTLINE_CHANGED: 'bị sửa nơi khác giữa chừng', STILL_UNVERIFIED: 'viết lại vẫn không xác minh được',
  AI_ERROR: 'lỗi gọi AI', NO_CLAIMS: 'AI không trả ý', BAD_STRUCTURE: 'AI trả sai cấu trúc', SOURCE_RANGE_STALE: 'chương nguồn đã đổi', EPISODE_NOT_FOUND: 'không còn tập này', GATE_FAILED: 'cổng không chấm được',
  NOT_EPISODE_UNIT: 'không phải lỗi của một tập', PROTECTED_UNDONE: 'bạn đã hoàn tác bản máy sửa', PROTECTED_MANUAL_EDIT: 'bạn đã sửa tay', PROTECTED_CHAT_EDIT: 'đã sửa qua trò chuyện', PROTECTED_RESTORE: 'bạn đã khôi phục bản cũ',
  CHANGED_BY_USER: 'bạn vừa đổi', GLOSSARY_MANUAL: 'cần sửa từ điển tên riêng bằng tay', POLICY_MANUAL: 'cần xem lại chính sách/bối cảnh', LOCKED_ENTITY: 'thực thể đã khoá', NO_ENTITY: 'không chỉ tới thực thể nào',
  ALIAS_MANUAL: 'lỗi ở bảng bí danh, cần sửa tay', NO_ALIAS_ROW: 'không có dòng bí danh', OVER_LIMIT: 'quá nhiều chỗ cần sửa một lượt', SCRIPTS_EXIST: 'đã có kịch bản tập, đổi tên sẽ lệch', OTHER: 'cần người xử lý',
};
export const roundSkipText = (code: string | null | undefined): string => (code && ROUND_SKIP_TEXT[code]) || 'cần người xử lý';

export interface GateWaitView {
  label: string;
  /** Câu chính: «Máy đã sửa {rounds} vòng, còn {N} lỗi ở Bản địa hoá». */
  sentence: string;
  /** Vì sao dừng. */
  reason: string;
  /** Các lỗi còn lại (tối đa `maxShown`), mỗi dòng «đơn vị — vấn đề»; thừa ⇒ dòng «…và M lỗi nữa». */
  issueLines: string[];
  count: number;
  /** Chưa biết còn lỗi nào (GATE_MISSING / GATE_STALE): không hiện số lỗi. */
  countKnown: boolean;
  openLabel: string;
  /** 3g2 (Q9): cổng ③ BLOCKED ⇒ dải KHÔNG đưa nút «Chạy tiếp, để lỗi xem sau» (bấm sẽ 409) mà đưa nút mở thẻ Bản địa hoá. */
  blocked: boolean;
  confirm: { title: string; content: string; okText: string };
}

const MAX_ISSUE_LINES = 5;
const trim = (s: string, n: number): string => (s.length > n ? `${s.slice(0, n - 1)}…` : s);

/** Dải/thẻ `WAIT_REVIEW_GATE`. `gateWait` vắng (dữ liệu hỏng) ⇒ vẫn trả thẻ an toàn, không ném. */
export const gateWaitView = (gw: AppendRunGateWait | null | undefined): GateWaitView => {
  const unresolved = gw?.unresolved ?? [];
  const count = unresolved.length;
  const stop = gw?.stopReason;
  const countKnown = stop !== 'GATE_MISSING' && stop !== 'GATE_STALE';
  const rounds = gw?.rounds ?? 0;
  const tried = rounds > 0 ? `Máy đã sửa ${rounds} vòng` : 'Máy chưa sửa vòng nào';
  const sentence = countKnown ? `${tried}, còn ${count} lỗi ở Bản địa hoá` : `${tried}; chưa biết còn bao nhiêu lỗi ở Bản địa hoá`;
  const issueLines = [
    ...unresolved.slice(0, MAX_ISSUE_LINES).map((i) => `${i.unit} — ${trim(String(i.problem ?? ''), 160)}`),
    ...(count > MAX_ISSUE_LINES ? [`…và ${count - MAX_ISSUE_LINES} lỗi nữa`] : []),
  ];
  return {
    label: REVIEW_GATE_LABEL, sentence, reason: gateStopText(stop), issueLines, count, countKnown, blocked: gw?.blocked === true,
    openLabel: gw?.blocked === true ? GATE_BLOCKED_OPEN_LABEL : countKnown && count > 0 ? `Xem ${count} lỗi ở ③` : GATE_OPEN_LABEL,
    confirm: {
      title: 'Chạy tiếp, để lỗi xem sau?',
      content: countKnown && count > 0
        ? `Máy sẽ chia tập ngay với ${count} lỗi còn lại ở Bản địa hoá. Các lỗi này được ghi lại để bạn xem sau ở ③; không gọi thêm AI cho cổng.`
        : 'Máy sẽ chia tập ngay mà không chờ cổng Bản địa hoá. Việc này được ghi lại để bạn xem sau ở ③; không gọi thêm AI cho cổng.',
      okText: 'Chạy tiếp',
    },
  };
};

// ─── Khối «lịch sử vòng» ở cổng ③④ ─────────────────────────────────────────

export interface RoundRow {
  round: number;
  /** «3 → 1» (số khoá lỗi trước → sau). */
  change: string;
  fixed: string;
  skipped: string[];
  note?: string;
}

export const roundRows = (gate: Pick<StepGate, 'autoFix'> | null | undefined): RoundRow[] => {
  const rounds: GateRound[] = gate?.autoFix?.rounds ?? [];
  return rounds.map((r) => {
    const fixedN = r.targets?.length ?? 0;
    const note = r.rolledBack ? 'Có lỗi sau khi sửa nên đã hoàn tác vòng này' : r.error ? 'Vòng này gặp lỗi' : undefined;
    return {
      round: r.round,
      change: `${r.beforeKeys?.length ?? 0} → ${r.afterKeys?.length ?? 0}`,
      fixed: fixedN ? `đã sửa ${fixedN}` : 'chưa sửa mục nào',
      skipped: (r.skipped ?? []).map((s) => `${s.target} (${roundSkipText(s.reason)})`),
      ...(note ? { note } : {}),
    };
  });
};

/** Dòng tóm kết quả chuỗi ở đầu khối lịch sử; không có `chainResult` ⇒ null (cổng chưa chạy trong chuỗi, hoặc chưa xong). */
export const chainResultLine = (gate: Pick<StepGate, 'chainResult' | 'chainOverride'> | null | undefined): string | null => {
  const cr = gate?.chainResult;
  if (!cr) return null;
  const n = cr.unresolved?.length ?? 0;
  const base = n === 0 ? `Máy sửa ${cr.rounds} vòng — sạch` : `Máy sửa ${cr.rounds} vòng — còn ${n} lỗi (${gateStopText(cr.stopReason)})`;
  const co = gate?.chainOverride;
  if (!co) return base;
  // 3g2 (Q7): bản ghi của MÁY (kind AUTO_CONTINUE / actor máy) hiện «Máy», không lộ mã actor.
  return co.kind === 'AUTO_CONTINUE' || co.by === MACHINE_ACTOR ? `${base}. Máy tự chạy tiếp, để lỗi xem sau` : `${base}. ${co.displayBy ?? co.by} đã chọn chạy tiếp, để lỗi xem sau`;
};
